import type { RouteRecordRaw } from 'vue-router';
import { FEATURE_FLAGS, ROLES } from '@AuthModule';

export default <RouteRecordRaw[]>[
  {
    path: 'field-services',
    name: 'field-services',
    redirect: '/shelter/field-services/cases',
    meta: {
      featureFlag: FEATURE_FLAGS.FIELD_SERVICES,
      permissions: [ROLES.FIELD_SERVICES],
    },
    children: [
      {
        path: 'cases',
        name: 'field-services-cases-table',
        component: () => import('./views/FieldServicesCases.view.vue'),
      },
      {
        path: 'dispatcher',
        name: 'field-services-dispatcher',
        component: () => import('./views/FieldServicesDispatcher.view.vue'),
        meta: {
          featureFlag: FEATURE_FLAGS.FIELD_SERVICES_DISPATCH,
          permissions: [ROLES.FIELD_SERVICES],
        },
      },
      {
        path: 'calendar',
        name: 'field-services-calendar',
        component: () => import('./views/FieldServicesCalendar.view.vue'),
        meta: {
          featureFlag: FEATURE_FLAGS.FIELD_SERVICES_DISPATCH,
        },
      },
      {
        path: 'map',
        name: 'field-services-cases-map',
        component: () => import('./views/FieldServicesMap.view.vue'),
      },
      {
        path: 'management',
        name: 'field-services-management',
        component: () => import('./views/FieldServicesManagement.view.vue'),
        meta: {
          featureFlag: FEATURE_FLAGS.FIELD_SERVICES_DISPATCH,
          permissions: [ROLES.FS_MANAGEMENT_DASHBOARD],
        },
      },
      {
        path: 'stats',
        name: 'field-services-cases-stats',
        component: () => import('./views/FieldServicesCaseStats.view.vue'),
      },
      {
        path: 'cases-archive',
        name: 'field-services-cases-archive',
        component: () => import('./views/FieldServicesCaseArchive.view.vue'),
      },
      {
        path: 'case-report',
        name: 'field-services-case-report',
        component: () => import('./views/FieldServicesCaseReport.view.vue'),
      },
      {
        path: 'bite-report',
        name: 'field-services-bite-report',
        component: () => import('./views/FieldServicesBiteReport.view.vue'),
      },
      {
        path: 'citation-report',
        name: 'field-services-reporting-table',
        component: () => import('./views/FieldServicesCitationReports.view.vue'),
      },
      {
        path: 'add-case',
        name: 'field-services-add-case',
        component: () => import('./views/FieldServicesAddCase.view.vue'),
      },
      {
        path: 'case/:id',
        name: 'field-services-cases-case',
        component: () => import('./views/FieldServicesCase.view.vue'),
      },
      {
        path: 'officer/:id',
        name: 'field-services-officer',
        component: () => import('./views/FieldServicesOfficer.view.vue'),
        meta: {
          featureFlag: FEATURE_FLAGS.FIELD_SERVICES_DISPATCH,
        },
      },
    ],
  },
];
